import { render } from "./Sidenav.vue?vue&type=template&id=79cfbbbf&scoped=true"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"

import "./Sidenav.vue?vue&type=style&index=0&id=79cfbbbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cfbbbf"]])

export default __exports__